/**
 * Transient hand-off for the assistant's "open a grid" action. The websocket handler (via App.vue) stores
 * an RSQL criteria keyed by resource just before navigating; the `AppDataGrid` for that resource consumes
 * it once at grid-ready and applies it as editable filter chips (RSQL -> filter model).
 *
 * A plain module map (not a store): no reactivity is needed — it's a one-shot set-then-consume handoff.
 * Not persisted, so a full page reload drops a pending filter — acceptable for an ephemeral action.
 */
const pending = new Map<string, string>();

export function setPendingGridFilter(resource: string, criteria: string): void {
	pending.set(resource, criteria);
}

/** Return and clear the pending criteria for `resource` (undefined if none). */
export function consumePendingGridFilter(resource: string): string | undefined {
	const criteria = pending.get(resource);
	if (criteria !== undefined) pending.delete(resource);
	return criteria;
}
